import React, { createContext, useReducer } from "react";
import { reducer, initialState } from "./reducers";
import { ACTIONS } from "./constants";
const FormBuilderContext = createContext(null);

const FormBuilderContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <FormBuilderContext.Provider value={value}>
      {children}
    </FormBuilderContext.Provider>
  );
};

export { FormBuilderContextProvider, FormBuilderContext, ACTIONS };
